export const CANCEL_REQUEST = 'CANCEL_REQUEST'

export const LANG_EN = 'en'
export const LANG_JP = 'jp'

export const LANG_LIST = [
    { content: '日本語', value: LANG_JP },
    { content: 'ENGLISH', value: LANG_EN }
]

// chart color
export const RANDOM_COLOR = [
    '#D04A02',
    '#eb8c00',
    '#ffb600',
    '#295477',
    '#299d8f',
    '#4577c9',
    '#00c6f7',
    '#3dd5b0',
    '#db536a',
    '#7d7d7d',
    '#dedede'
]

export const MENU_LIST = {
    CLIENT_MANAGEMENT: {
        path: '/clientManagement',
        displayName: 'menu.clientManagement'
    },
    CLIENT_MANAGEMENT_DETAIL: {
        path: '/clientManagement/:id',
        displayName: 'menu.clientManagement'
    }
}

export const BRAND_FONT = 'Helvetica Neue Regular, Noto Sans JP'

export const V2_HOME = '/v2/chooseCmp'
export const ADMIN_HOME = '/clientManagement'
export const ANALYSIS_HOME = '/analysis/list'
export const THEME_PAGE_URL = '/v2/themePage'
export const COMPANY_PAGE_URL = '/v2/companyDetail'

export const HOST_NAME_PRODUCTION = 'https://intelligentbusinessanalytics.jp.pwc.com'
